export default __webpack_public_path__ + "static/media/small-clip.c7975b71.svg";